<div class="user-menu">

  <ac-menu-user-info [operator]="username"
                     [operatorAuthenticationMode]="operatorAuthenticationMode">
    <div class="user-menu-details">
      <p [title]="fullUserSecurityRoles ? fullUserSecurityRoles: ''">{{userSecurityRoles}}</p>
      <p>Version: {{productVersion}}</p>
      <div *ngIf="saasEnabled">
        SaaS Mode Enabled
      </div>
    </div>
  </ac-menu-user-info>

  <ac-menu-options (onAction)="onAction($event)" [sections]="sections"></ac-menu-options>

  <ac-menu-countdown id="ac-menu-countdown"
                     *ngIf="sessionTimeout"
                     [acTimeStamp]="sessionTimeout">
  </ac-menu-countdown>

</div>
